export const shadowOptions = [
	'shadow-none', 'shadow-sm', 'shadow', 'shadow-md', 'shadow-lg', 'shadow-xl',
];

export const roundedOptions = [
	'rounded-none', 'rounded-sm', 'rounded', 'rounded-md', 'rounded-lg',
	'rounded-xl', 'rounded-2xl', 'rounded-3xl', 'rounded-full',
];

export const fontSizeOptions = [
	'default', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '28px', '32px', '36px', '40px', '48px',
];

export const spacingOptions = [
	'space-y-1', 'space-y-2', 'space-y-3', 'space-y-4', 'space-y-5', 'space-y-6',
];

export const verticalMarginOptions = [
	'my-0', 'my-1 @sm:my-2', 'my-2 @sm:my-4', 'my-3 @sm:my-6', 'my-4 @sm:my-8', 'my-6 @sm:my-12', 'my-8 @sm:my-16',
	'my-12 @sm:my-24', 'my-16 @sm:my-32', 'my-20 @sm:my-40', 'my-24 @sm:my-48', 'my-32 @sm:my-64',
	'my-40 @sm:my-80', 'my-48 @sm:my-96', 'my-56 @sm:my-[448px]', 'my-64 @sm:my-[544px]',
];

export const horizontalPaddingOptions = [
	'px-0', 'px-1 @sm:px-2', 'px-2 @sm:px-4', 'px-3 @sm:px-6', 'px-4 @sm:px-8', 'px-6 @sm:px-12', 'px-8 @sm:px-16',
];

export const containerWidthOptions = [
	'600px', '750px', '850px', '1000px', '1150px', '1300px', 'none',
];

export const textTagOptions = [
	{ label: 'p', value: 'p' },
	{ label: 'h1', value: 'h1' },
	{ label: 'h2', value: 'h2' },
	{ label: 'h3', value: 'h3' },
	{ label: 'h4', value: 'h4' },
	{ label: 'h5', value: 'h5' },
	{ label: 'h6', value: 'h6' },
];
